module.exports = __webpack_public_path__ + "static/img/traffic-charactor-hand.ae5def1f.svg";